module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/56ed3470ff2a975158e03fa7eb673886.gif";